import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useAPI } from 'console/shared/api/api-context';
import { AccessPage } from 'entities/device.acl/ui/page';
export function AccessPageWithAPI(props) {
    const api = useAPI();
    const check_username = useCallback((username) => api.check_username(username), [api]);
    return _jsx(AccessPage, { check_username: check_username, ...props });
}
